<template>
    <div class="wizard-container row">
        <div class="col-md-12 text-right" style="margin-bottom : 15px;">
            <button class="btn btn-primary" :disabled=shouldDisableProcessAllButton type="button" @click.stop=onConfirmProcessing>Procesar Todo</button>
        </div>
        <wizard-card v-for="row in data" :key=row.idClass :clase=row :areInactiveClasses=areInactiveClasses></wizard-card>
		<div class="empty-wizard" v-if=hasNoData> <!--Show this when data is empty (no classes found)-->
			<img :src="'generic/reportesSindatos.png' | baseImg">
			<h5>Actualmente no hay clases a las que se les pueda agregar participantes.</h5>
		</div>
        <v-dialog/>
    </div>
</template>

<script>
import WizardCard from './DepClassesWizardCard';
import ConfirmModal from '@/components/global/modal/ModalConfirmation';

export default {
    props : ['moduleSource'],
    components : { WizardCard, ConfirmModal },
    data() {
        return {
            confirmStyle: {
				width: 500,
				height: 'auto',
				pivotY: .1,
				name: 'confirm-modal'
			}
        }
    },
    computed : {
        data() {
            return this.$store.state[this.moduleSource].table.data;
        },
        selectedFilters() {
            return this.$store.state[this.moduleSource].filters.filtersSelection;
		},
		hasNoData() {
			return this.data.length == 0;
		},
		areInactiveClasses() {
			return this.selectedFilters.classStatus == "INC";
		},
		shouldDisableProcessAllButton() {
			let areJustIgnoredClasses = this.selectedFilters.classStatusWizard ?
				(this.selectedFilters.classStatusWizard[0] == "9b290bf8-70ba-11e7-ae75-3fdfa392f207") : false;

			return this.hasNoData || this.areInactiveClasses || areJustIgnoredClasses;
		}
    },
    methods : {
        onConfirmProcessing() { /** Ask user for confirmation, then invoke processAll service **/
            let message = this.$store.state[this.moduleSource].table.totalRows > 1 ? `¿Está seguro que desea procesar las ${this.$store.state[this.moduleSource].table.totalRows} clases?` : "¿Está seguro que desea procesar la clase?";

            this.$modal.show(ConfirmModal, {
                title : 'Confirmar procesamiento de clases',
                text : message,
                okHandler : this.onProcessAll
            }, this.confirmStyle, { });
        },
        onProcessAll() {
			/** Copy objects from store, to avoid state mutation from here (Maybe it would be cleaner to user getters)**/
            let _classStatusWizard = this.selectedFilters.classStatusWizard ? Array.from(Object.create(this.selectedFilters.classStatusWizard)) : [];
            let _pathway = this.selectedFilters.pathway ? Array.from(Object.create(this.selectedFilters.pathway)) : null;

            let filters = {
                searchText : this.$store.state[this.moduleSource].table.searchKey,
                groups : this.$store.getters[this.moduleSource + "/groups"],
                pathway : _pathway ? _pathway.pop() : "",
                classStatus : [],
                classStatusWizard : _classStatusWizard ? _classStatusWizard.map(el => { return {idClassStatusWizard : el}; }) : []
            };
            this.$modal.hide(this.confirmStyle.name); //Close confirmation modal

            this.$showLoading(); //Show Dep FullScreen Loader (Works only in frankie)
            this.$depAPI.classes.processAllClassesInWizard(filters).then(response => {
				if(response.status != 200) { //If service response is not Ok (200), then show error message
					this.$toast.error({title : "Ocurrió un error al procesar. Intente de nuevo"});
				} else { //Show success message and reload table
					this.$toast.success({title : "Las clases han sido procesadas"});
					this.$parent.refreshData();
				}
                this.$hideLoading(); //Show Dep FullScreen Loader
            });
        }
    }
}
</script>

<style lang="scss">
.wizard-container {
    width : 100%;
    margin : 0 auto;
}

.empty-wizard {
	width : 100%;
	height : 100%;
	min-height : 400px;
	display : flex;
	flex-direction : column;
	align-items : center;
	justify-content: center;	
}
</style>

